import { SVGProps } from 'react';

const SvgChartPieSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M495.4 240c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6V240h223.4zM176 288c0 26.5 21.5 48 48 48h197.1c-26.4 74.6-97.5 128-181.1 128-106 0-192-86-192-192 0-83.6 53.4-154.7 128-181.1V288zm48-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.6 107.5 240 240 240 115.5 0 211.9-81.5 234.8-190.2 3.8-18.1-11-33.8-29.5-33.8H224V66.7z" />
  </svg>
);
export default SvgChartPieSimple;
